import React from 'react';

import '../../assets/css/bootstrap.min.css'
import '../../assets/css/all.min.css'
import '../../assets/css/swiper-bundle.min.css'
import '../../assets/css/magnific-popup.css'
import '../../assets/css/animate.css'
import '../../assets/css/nice-select.css'
import '../../assets/css/style.css'
import '../../assets/css/aboutUs.css'

const AboutUs = () => {
  return (
    <section className="about pt-20 pb-20">
      <div className="about__leaf fall__animation">
        <img src="/images/about/leaf.png" alt="leaf"/>
      </div>
      <div className="container">
        <div className="row align-items-center justify-content-between">
          <div className="col-xl-6">
            <div className="section-header mb-5">
              <h5 className="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".2s">
                <img src="/images/icon/leaf.png" alt="leaf" style={{display:"inline"}}/> ABOUT US
              </h5>
              <h2 className="wow fadeInUp mb-2" data-wow-duration="1.4s" data-wow-delay=".4s">
                Environment & Sustainability Goals
              </h2>
              {/* <p className="wow fadeInUp" data-wow-duration="1.6s" data-wow-delay=".6s">
                ENCORRA ESG, the sustainability subsidiary of ImageIO, provides comprehensive solutions in the ESG practise to enable organizations, groups, and individuals to understand, assess, implement, and achieve a positive footprint in the goals and regulations established by the authorities.
              </p> */}
              <div>
              <p className="wow fadeInUp" data-wow-duration="1.6s" data-wow-delay=".6s">
                We at ENCORRA ESG, the sustainability subsidiary of ImageIO, believe that accountability
                is the first step towards real change in the environment. We deliver holistic ESG solutions
                that enable organizations, groups, and individuals to increase their ESG awareness and
                evaluate and identify strategies to make a positive impact. Aranya Setu is our flagship
                platform designed to provide transparency in CSR and plantation activities in India. It
                allows organizations to keep a close watch on tree growth in real time, record survival
                rates, and accurately measure environmental benefits. By leveraging data-driven insights,
                businesses and NGOs can shift from mere green promises to tangible, measurable, and
                meaningful impact. Each tree planted under Aranya Setu is a story of CO₂ captured,
                ecosystems restored, and commitments honored. We are creating a future in which
                sustainability is not only promised but proven.
              </p>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="d-flex align-items-center justify-content-between">
              <div className="aboutUsComp relative bg-gradient-to-r from-teal-400 to-green-500 rounded-md overflow-hidden w-16rem" style={{ margin: '0px 5px' }}>
                <h4 className="relative z-10 text-white leading-none font-semibold">80%</h4>
                <div className="relative z-10 text-green-200 leading-none font-semibold  text-center">Carbon Offsetting</div>
                <img src="/images/carbon-footprint.png" className="aboutUsCompImg" alt="Carbon Offsetting" />
              </div>
              <div className="aboutUsComp relative bg-gradient-to-r from-blue-400 to-blue-600 rounded-md overflow-hidden w-16rem" style={{ margin: '0px 5px' }}>
                <h4 className="relative z-10 text-white leading-none font-semibold">85%</h4>
                <div className="relative z-10 text-blue-200 leading-none font-semibold  text-center">Water Conservation</div>
                <img src="/images/save-water.png" className="aboutUsCompImg" alt="Water Conservation" />
              </div>
              <div className="aboutUsComp relative bg-gradient-to-r from-red-400 to-red-600 rounded-md overflow-hidden w-16rem" style={{ margin: '0px 5px' }}>
                <h4 className="relative z-10 text-white leading-none font-semibold">90%</h4>
                <div className="relative z-10 text-red-200 leading-none font-semibold  text-center">E-Waste Recycling</div>
                <img src="/images/ewaste.png" className="aboutUsCompImg" alt="E-Waste Recycling" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;